import { ThreeCircles } from 'react-loader-spinner';
import styled from 'styled-components';
import LoadingStore from './LoadingStore';
import { useAtom } from 'jotai';

interface LoadingProps {}

const Loading: React.FC<LoadingProps> = (props) => {
  const [loading, setLoading] = useAtom(LoadingStore);
  return loading ? (
    <UI_Wrapper>
      <ThreeCircles
        visible={true}
        height="100"
        width="100"
        color="#4fa94d"
        ariaLabel="three-circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </UI_Wrapper>
  ) : null;
};

export default Loading;

const UI_Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;
